module.exports = __webpack_public_path__ + "static/media/companyHub-new_post.e6c730b9.png";